import { Configuration, PublicClientApplication, RedirectRequest } from "@azure/msal-browser";

// Config object to be passed to Msal on creation
export const loginRequest: RedirectRequest = {
  scopes: [`${process.env.REACT_APP_ADAL_CLIENT_ID}`, "openid"],
};

const baseAuthority = `https://${process.env.REACT_APP_ADAL_TENANT ?? ""}.b2clogin.com/${
  process.env.REACT_APP_ADAL_TENANT ?? ""
}.onmicrosoft.com/`;
export const msalConfig: Configuration = {
  auth: {
    authority: `${baseAuthority}${process.env.REACT_APP_ADAL_POLICY_ID ?? ""}`,
    clientId: process.env.REACT_APP_ADAL_CLIENT_ID ?? "",
    knownAuthorities: [`https://${process.env.REACT_APP_ADAL_TENANT ?? ""}.b2clogin.com`],
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    // storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

/**
 * Initiates password reset flow using MSAL with Authorization Code + PKCE.
 * This replaces the legacy implicit flow (response_type=id_token).
 */
export const initiatePasswordReset = () => {
  const passwordResetAuthority = `${baseAuthority}${process.env.REACT_APP_ADAL_PASSWORD_RESET_FLOW ?? ""}`;

  return msalInstance.loginRedirect({
    authority: passwordResetAuthority,
    scopes: ["openid"],
    prompt: "login",
  });
};
export const logIn = () => msalInstance.loginRedirect(loginRequest);
export const getMsalUser = () => msalInstance.getAllAccounts()[0];
export const getUserName = () => msalInstance.getAllAccounts()[0]?.name ?? "";
export const getInitials = () => {
  const name = getUserName();
  const names = name.split(" ");
  const initials = names.map((n) => n.substring(0, 1).toUpperCase()).join("");
  return initials;
};
export const useLogIn = () => {
  return () =>
    logIn().catch((e) => {
      console.log(e);
    });
};

export const getTokenAsync = async () => {
  const activeAccount = msalInstance.getActiveAccount(); // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API
  const accounts = msalInstance.getAllAccounts();

  if (!activeAccount && accounts.length === 0) {
    return msalInstance.loginRedirect();
  }
  const request = {
    ...loginRequest,
    account: activeAccount ?? accounts[0],
  };

  const authResult = await msalInstance.acquireTokenSilent(request);
  return authResult.accessToken;
};

export const getDecodedJWT = () => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  return msalInstance.getActiveAccount();
};

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export const logout = async () => msalInstance.logoutRedirect();
